/* Native Shopify prices and eligibility remain authoritative. No coupon is issued here. */
(() => {
  if (window.WotfWelcomeOffer) return;
  const script = document.querySelector('[data-welcome-controller]');
  const cartUrl = script?.dataset.cartUrl || '/cart';
  const endpoint = cartUrl.replace(/\/$/, '');
  const root = document.querySelector('[data-welcome-offer]');
  const preview = root?.dataset.preview === 'true';
  let activeCode = '';
  const readCode = () => { if(activeCode) return activeCode; try { return sessionStorage.getItem('wotf:welcome-code') || ''; } catch { return ''; } };
  const saveCode = code => { activeCode = code; try { sessionStorage.setItem('wotf:welcome-code', code); } catch {} };
  const codePattern = /^WELCOME15-[A-Z0-9-]{1,64}$/i;
  let pending = null;
  let appliedCart = null;
  function discounts(cart) {
    const lineSavings = Math.max(0, cart.original_total_price - cart.items_subtotal_price);
    return { original: cart.original_total_price, lineSavings, applications: cart.cart_level_discount_applications || [], saved: cart.total_discount, total: cart.total_price };
  }
  function isWelcome(cart) {
    return cart.total_discount > 0 && (cart.cart_level_discount_applications || []).some(d =>
      /^WELCOME15-/i.test(d.title || '') || d.title === 'The World of The Fool — first-order welcome coupon');
  }
  async function fetchCart() {
    const response = await fetch(endpoint + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw Error('Your cart could not be checked.');
    return response.json();
  }
  async function applyWelcome(cart) {
    const code = readCode();
    if (preview || !codePattern.test(code)) return null;
    if (pending) return pending;
    pending = (async () => {
      const current = cart || await fetchCart();
      // Keep any existing offer, including a member's 20% or a campaign's 25%.
      if (!current.items?.length || isWelcome(current) || current.total_discount > 0) return current;
      const key = current.token + ':' + current.original_total_price + ':' + current.item_count + ':' + code;
      if (key === appliedCart) return current;
      appliedCart = key;
      const editor = document.querySelector('cart-editor');
      if (editor?.busy || window.TotfCart?.isBusy?.()) { appliedCart = null; return current; }
      if (typeof editor?.update === 'function') {
        await editor.update({ discount: code }, null, 'discount');
        return null;
      }
      const response = await fetch(endpoint + '/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: code }),
      });
      if (!response.ok) throw Error('Your coupon could not be checked.');
      const updated = await response.json();
      if (document.querySelector('#TotfCart[open]')) await window.TotfCart?.reload?.();
      return updated;
    })().catch(() => { appliedCart = null; return null; }).finally(() => { pending = null; });
    return pending;
  }
  window.WotfWelcomeOffer = { applyWelcome, discounts, isWelcome };
  // A customer's coupon email links to /cart?welcome_code=...; never create a code in the browser.
  const params = new URLSearchParams(location.search);
  const incoming = params.get('welcome_code');
  if (!preview && codePattern.test(incoming || '')) {
    saveCode(incoming);
    params.delete('welcome_code');
    history.replaceState(history.state, '', location.pathname + (params.size ? '?' + params.toString() : '') + location.hash);
  }
  if (!preview && readCode()) applyWelcome();
  document.addEventListener('totf:cart-updated', event => { if (!pending) applyWelcome(event.detail?.cart); });
  if (!root) return;
  const dialog = root.querySelector('dialog');
  const openButton = root.querySelector('[data-offer-open]');
  const intro = root.querySelector('[data-offer-intro]');
  const signup = root.querySelector('[data-offer-signup]');
  let returnFocus = null;
  function stage(subscribe) {
    intro.hidden = subscribe; signup.hidden = !subscribe;
    (subscribe ? signup.querySelector('input:not(:disabled),h3') : root.querySelector('[data-offer-accept]'))?.focus({ preventScroll:true });
  }
  function open() {
    if (document.querySelector('dialog[open]')) return;
    returnFocus = document.activeElement;
    const image = root.querySelector('[data-offer-image]');
    if (!image.src) { image.src = image.dataset.src; image.addEventListener('error', () => image.hidden = true, { once:true }); }
    dialog.showModal();
  }
  openButton.addEventListener('click', open);
  root.querySelectorAll('[data-offer-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
  root.querySelector('[data-offer-accept]').addEventListener('click', () => stage(true));
  root.querySelector('[data-offer-back]').addEventListener('click', () => stage(false));
  dialog.addEventListener('close', () => returnFocus?.isConnected && returnFocus.focus({ preventScroll:true }));
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const b = dialog.getBoundingClientRect();
    if (event.clientX < b.left || event.clientX > b.right || event.clientY < b.top || event.clientY > b.bottom) dialog.close();
  });
  // Native <dialog> provides modal focus confinement and Escape handling.
  const form = root.querySelector('form');
  let submitted = false;
  form.addEventListener('submit', event => {
    if (preview || submitted) { event.preventDefault(); return; }
    if (!form.reportValidity()) { event.preventDefault(); return; }
    submitted = true;
    form.querySelector('[type=submit]').disabled = true;
  });
  window.addEventListener('pageshow', () => { submitted = false; if (!preview) form.querySelector('[type=submit]').disabled = false; });
  if (root.querySelector('[data-offer-subscribed],[data-offer-error]')) { stage(true); open(); }
})();
